import PropTypes from "prop-types";
import { Card, Typography } from "@mui/material";
import { formatNumber } from "src/utils/formatNumberHelper";

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  caption: PropTypes.string,
  sx: PropTypes.object,
};

export default function AppWidgetSummary({
  title,
  total,
  caption,
  icon,
  color = "primary",
  sx,
  format = "number",
  ...other
}) {
  return (
    <Card
      sx={{
        py: 2,
        px: 2,
        boxShadow: 0,
        textAlign: "center",
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h5">{formatNumber(total, format)}</Typography>

      <Typography variant="subtitle4" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>

      {caption && (
        <Typography variant="caption" sx={{ display: "block", opacity: 0.72 }}>
          {caption}
        </Typography>
      )}
    </Card>
  );
}
